import FileModel from '@/VueComponents/FileUploadSelector/models/fileModel';
import { FileUploadType } from '@/VueComponents/FileUploadSelector/enums/fileUploadType';

export default class UploadSelectorFileUploadModel extends FileModel {
  type: FileUploadType;

  constructor(file: FileModel, type: FileUploadType) {
    super(file.name, file.path, file.file);
    this.type = type;
  }

  static fromFileWithType(file: File, type: FileUploadType): UploadSelectorFileUploadModel {
    const fileModel = FileModel.fromFile(file);
    return new UploadSelectorFileUploadModel(fileModel, type);
  }
}